import { initializeApp } from 'firebase/app';
import { getFirestore } from 'firebase/firestore';
import { getStorage } from 'firebase/storage';

const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY || 'AIzaSyBla4pzD_-XDfz7-gVn4oQfvnzfBKwc_aw',
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || 'dieu-wedding.firebaseapp.com',
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || 'dieu-wedding',
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || 'dieu-wedding.firebasestorage.app',
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || '252808036147',
  appId: import.meta.env.VITE_FIREBASE_APP_ID || '1:252808036147:web:f1a1a757c17e3564d70846',
  measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || 'G-SFS01LJ0DF',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
